/**
 * Comparison function for sorting strings
 */
export function compareStrings(a: string | null | undefined, b: string | null | undefined): number {
    return (a || '').localeCompare(b || '');
}